var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoIconinline = function SvgInfoIconinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#21201F",
    d: "M10 0a10 10 0 1 0 10 10A10.02 10.02 0 0 0 10 0m-.192 4.615a1.154 1.154 0 1 1 0 2.308 1.154 1.154 0 0 1 0-2.308m.961 10.77H10a.77.77 0 0 1-.77-.77V10a.77.77 0 0 1 0-1.538H10a.77.77 0 0 1 .77.769v4.615a.77.77 0 1 1 0 1.539"
  })));
};
export default SvgInfoIconinline;